module.exports = __webpack_public_path__ + "static/st1-10-76d87f0b09867428d9155e2e6ca52ad0.jpg";